import { createResourceContentSelector } from 'util/selector/resourceSelector';

import { createSelector } from '@reduxjs/toolkit';
import { TimezoneModel } from 'api/dto/Timezone.dto';
import { AutocompleteData } from 'component/Form/Autocomplete';
import { AdminState } from 'reduxStore/appStore';

export const selectConstantsResource = (state: AdminState) => state.configs.constants;

export const selectTimezonesResource = (state: AdminState) => state.configs.timezones;

export const selectConstants = createResourceContentSelector(selectConstantsResource);

export const selectBenchmarkSectors = createSelector(selectConstants, (domain) =>
  domain ? domain.benchmarkSectors : [],
);

export const selectPulseFrequencies = createSelector(selectConstants, (domain) =>
  domain ? domain.pulseFrequencies : [],
);

export const selectEmployeeRangeGroup = createSelector(selectConstants, (domain) =>
  domain ? domain.employeeRangeGroup : [],
);

export const selectDemographicConstants = createSelector(selectConstants, (domain) =>
  domain ? domain.demographics : [],
);

export const selectDemographicEmploySinceConstant = createSelector(
  selectDemographicConstants,
  (demographics) => demographics.find((item) => item.key === 'DEMOGRAPHY_DATE_EMPLOYED_SINCE'),
);

export const selectDemographicDateOfBirthConstant = createSelector(
  selectDemographicConstants,
  (demographics) => demographics.find((item) => item.key === 'DEMOGRAPHY_DATE_OF_BIRTH'),
);

export const selectTimezones = createResourceContentSelector(selectTimezonesResource);

export const selectTimezoneAutocompleteOptions = createSelector(
  selectTimezones,
  (timezones): AutocompleteData<string>[] => {
    return timezones
      ? timezones.map((timezone: TimezoneModel) => ({
          text: `(${timezone.offset}) ${timezone.name}`,
          value: timezone.id,
        }))
      : [];
  },
);
